const escapeTagName = tag => {
  const t = tag.toLowerCase().replace(`#`, `-sharp`)
  if (Array.from(t)[0] === ".") {
    return t.slice(1)
  }
  return t
}

module.exports = escapeTagName
